import { setShowPrintButton } from "@redux/actions/global";
import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { IconApp } from "./IconApp";

const ModalAppV2 = ({
    children,
    Action = null,

    //modal
    titleModal = "",
    size = "lg",
    backdrop = "static",
    keyboard = false,
    hiddenCloseButton = false,
    enforceFocus = true,

    //button
    variant = "primary",
    icon = "",
    float = null,
    textButton = "",
    classNameButton = "",
    styleButton = {},
    disabled = false,
    onClickButton = () => {},

    //Controlar el modal por fuera
    openModal = false,
    hiddenButtonOnOpen = false,

    hiddenPrintButtonOnOpen = false,
    setModalAction = () => {},
}) => {
    const dispatch = useDispatch();

    const [isOpenModal, setIsOpenModal] = useState(false);
    const [isVisibleButton, setVisibleButton] = useState(true);

    useEffect(() => {
        setIsOpenModal(openModal);
    }, [openModal]);

    useEffect(() => {
        if (hiddenButtonOnOpen) {
            setVisibleButton(!isOpenModal);

            if (hiddenPrintButtonOnOpen) {
                dispatch(setShowPrintButton(!isOpenModal));
            }
        }
    }, [isOpenModal]);

    const handleClickButton = () => {
        if (disabled) return;
        setIsOpenModal(true);
        onClickButton(true);
        setModalAction(true);
    };

    const handleCloseButton = (callback = () => {}) => {
        setIsOpenModal(false);
        onClickButton(false);
        setModalAction(false);
        setIsOpenModal;
        if (typeof callback === "function") {
            callback();
        }
    };

    const CloseButton = (callback = () => {}) => (
        <Button variant="secondary" onClick={() => handleCloseButton(callback)}>
            Cerrar
        </Button>
    );

    const childrenWithProps = React.Children.map(children, (child) => {
        // Clonamos cada hijo y le pasamos la propiedad extra
        // return React.cloneElement(child, { extraProp });
        return React.cloneElement(child, {
            closeButton: CloseButton,
            handleCloseButton,
            handleClickButton,
        });
    });

    return (
        <>
            <span onClick={handleClickButton} style={{ margin: 0, padding: 0 }}>
                {isVisibleButton && (
                    <>
                        {!Action ? (
                            <Button
                                variant={variant}
                                className={classNameButton}
                                style={styleButton}
                                disabled={disabled}
                            >
                                {icon && (
                                    <IconApp iconClassName={`${icon} me-2`} />
                                )}
                                {textButton}
                            </Button>
                        ) : (
                            <Action />
                        )}
                    </>
                )}
            </span>

            <Modal
                show={isOpenModal}
                onHide={handleCloseButton}
                backdrop={backdrop}
                keyboard={keyboard}
                autoFocus
                size={size}
                enforceFocus={enforceFocus}
            >
                <Modal.Header>
                    <Modal.Title
                        className={`flex-grow-1 ${true && "text-center"}`}
                    >
                        {titleModal}
                    </Modal.Title>
                    {!hiddenCloseButton && (
                        <IconApp
                            onClick={handleCloseButton}
                            isClickable
                            iconClassName="fa fa-close"
                            fontSize="18px"
                        />
                    )}
                </Modal.Header>

                {childrenWithProps}
                {/* <Component
                    closeButton={CloseButton}
                    handleCloseButton={handleCloseButton}
                    handleClickButton={handleClickButton}
                /> */}
            </Modal>
        </>
    );
};

export default ModalAppV2;
